import { Editor } from "@tiptap/react";
import { useEffect } from "react";
import useEditorMode from "./useEditorMode";
import { useExternalChange } from "../external-update-context";
// Used for handling fullscreen edge case as well as live updating edge case
const useExternalChanges = (editor: Editor | null, initialContent: string) => {
  const mode = useEditorMode();
  const { isExternalChangeInProcess } = useExternalChange();

  useEffect(() => {
    if (
      editor &&
      initialContent !== undefined &&
      (isExternalChangeInProcess || !editor?.isEditable)
    )
      editor.commands.setContent(initialContent, true, {
        preserveWhitespace: "full",
      });
  }, [editor, initialContent, mode, isExternalChangeInProcess]);
};

export default useExternalChanges;
